import React from "react";
import {withRouter} from 'react-router-dom';
import {css} from "emotion";
import {colors, textSizes} from "../styles/theme";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";

const TitleWithBackButton = ({backLocation, lastLocation, title, subtitle, history}) => {
  const handleGoBack = () => {
    history.push(lastLocation);
  };

  return (
    <div className={container + ' title-with-back-button'}>
      {lastLocation ? (
        <div className='back-button' onClick={handleGoBack}>
          <FontAwesomeIcon className="icon" icon="chevron-left"/>
          BACK
        </div>
      ) : (
        <Link className='back-button' to={`/${backLocation}`}>
          <FontAwesomeIcon className="icon" icon="chevron-left"/>
          BACK
        </Link>
      )
      }
      <h3>{title} {subtitle && <span>{subtitle}</span>}</h3>
    </div>
  );
};

export default withRouter(TitleWithBackButton);

const container = css`
  margin-top: -3px;

  .back-button {
    text-decoration: none;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    letter-spacing: 1px;
    cursor: pointer;
    
    .icon {
      margin-right: 5px;
    }
  }
  
  h3 {
    font-size: ${textSizes.title};
  }
  
  span {
    color: ${colors.subtitleColor};
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: normal;
    margin-left: 15px;
    position: relative;
    bottom: 3px;
  }
  
  margin-bottom: 10px;
`;
